import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Minimal default resources; expand as needed
const resources = {
  en: {
    translation: {
      common: {
        loading: "Loading...",
      },
      submit: {
        send_activation_pin: "Send Activation Pin",
        submit: "Submit",
        enter_pin_label: "Enter the activation pin sent to your email:",
      },
      password: {
        password_label: "Password",
        confirm_password_label: "Confirm Password",
        enter_password_required: "Please enter a password to register your account",
        passwords_do_not_match: "The passwords do not match",
      },
      labeled_input: {
        true: "True",
        false: "False",
        date_placeholder: "mm/dd/yyyy",
        is_required_suffix: " is required",
      },
      registration: {
        confirm_or_edit_header: "Please confirm or edit the information below:",
        groups_header: "I want to receive notifications from the following groups:",
        contact_prefs_header: "Contact Preferences:",
        language_preference_label: "Language Preference",
        language_preference_tooltip:
          "Messages will be translated to your preferred language if the sender enables automatic translation. Translation errors are possible.",
        sso_info:
          "Your company uses Single Sign-On to access AlertMedia. A password is not required to log in, but it can be used in the event your SSO credentials are not working. Both options are available in the web dashboard and mobile app. Note: a password is not required to receive notifications.",
        password_optional_info:
          "Create a password to log into the mobile app and web dashboard to view and respond to notifications or request help from the Admin team. Note: a password is not required to receive notifications.",
        tos_with_link: "I accept the <a>AlertMedia Terms of Service</a>",
        error_generic: "Unable to complete registration or update. Please contact your administrator for further assistance.",
        error_accept_tos: "Please read and accept the AlertMedia Terms of Service",
        error_review: "Review and correct the above errors to try again",
        field_error_with_label: "{{message}} for {{label}}",
        terms_of_service: "Terms of Service",
        privacy_policy: "Privacy Policy",
        opt_in_sms_info: "By providing your cell phone number you consent to receive periodic updates from {{brand}} Powered by AlertMedia. Message frequency will vary. Text HELP for help, STOP to end. Message & Data rates may apply.",
      },
      success: {
        updated_profile: "You have successfully updated your profile.",
        subscribed_text: "You have been successfully subscribed to receive important notifications from {{customerName}}.",
        next_text:
          "Next, <loginLink>sign in to AlertMedia</loginLink> to explore the platform, and download the app for <iosLink>iPhone</iosLink> or <androidLink>Android</androidLink> to stay connected from your mobile devices.",
        download_app_cta: "DOWNLOAD THE ALERTMEDIA APP TO STAY CONNECTED!",
      },
      footer: {
        powered_by_alt: "Powered by AlertMedia",
        powered_by_title: "Powered by AlertMedia",
      },
      registration_form_container: {
        thank_you_signing_up: "Thank you for signing up",
        profile_updated: "Profile updated",
        error: "Error",
      },
      safesignal: {
        enrolling_checkbox_label: "I will also be enrolling in Safety Monitoring",
        enrollment_header: "Safety Monitoring - Enrollment",
        video_fallback: "Your browser does not support HTML5 video.",
        additional_required_info_header: "Required Information",
        additional_info_header: "Additional Information",
        tos_with_link: "I accept the <a>Safety Monitoring Terms of Service</a>",
        tos_aria_label: "End User Terms of Service",
      },
    },
  },
};

i18n
  // Pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    // Keep compatibility with React 17 render timing
    react: {
      useSuspense: false,
    },
  });

export default i18n;
